import { useState } from "react";
import axios from "axios";
import { API } from "../../App";

const MSG = {
  name: "Add your name so we know who to write to.",
  email: "That email doesn't look right. Check it and try again.",
  business: "Tell us what your business does.",
  goal: "Tell us the one goal you'd bring.",
  consent: "Tick the box so we can email you about Sojourns.",
  server: "That didn't send. Email hola@savicoliving.com and we'll add you.",
};
const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;

// Register your interest, or (once the gate is open) apply. Validates client side with the exact messages,
// posts with utm + page url, honeypot included.
export default function RegisterForm({ onSuccess, apply = false }) {
  const [form, setForm] = useState({ name: "", email: "", business: "", link: "", goal: "", consent: false, website: "" });
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return setError(MSG.name);
    if (!EMAIL_RE.test(form.email.trim())) return setError(MSG.email);
    if (apply && !form.business.trim()) return setError(MSG.business);
    if (apply && !form.goal.trim()) return setError(MSG.goal);
    if (!form.consent) return setError(MSG.consent);
    setError("");
    setSending(true);
    const q = new URLSearchParams(window.location.search);
    try {
      await axios.post(`${API}/sojourns/${apply ? "apply" : "register"}`, {
        ...form,
        page_url: window.location.href,
        utm_source: q.get("utm_source") || "",
        utm_medium: q.get("utm_medium") || "",
        utm_campaign: q.get("utm_campaign") || "",
      });
      onSuccess();
    } catch (err) {
      const status = err?.response?.status;
      setError(status === 400 ? err.response.data?.detail || MSG.server : MSG.server);
    } finally {
      setSending(false);
    }
  };

  return (
    <form className="sj-form" onSubmit={submit} noValidate data-testid="sojourns-form" data-mode={apply ? "apply" : "register"}>
      <div className="sj-field">
        <label htmlFor="sj-name">Name</label>
        <input id="sj-name" type="text" name="name" autoComplete="name" value={form.name} onChange={set("name")} required data-testid="sojourns-name" />
      </div>
      <div className="sj-field">
        <label htmlFor="sj-email">Email</label>
        <input id="sj-email" type="email" name="email" autoComplete="email" inputMode="email" value={form.email} onChange={set("email")} required data-testid="sojourns-email" />
      </div>
      <div className="sj-field">
        <label htmlFor="sj-business">What your business does</label>
        <input id="sj-business" type="text" name="business" value={form.business} onChange={set("business")} required={apply} data-testid="sojourns-business" />
      </div>
      <div className="sj-field">
        <label htmlFor="sj-link">Your LinkedIn or website</label>
        <input id="sj-link" type="text" name="link" inputMode="url" autoComplete="url" value={form.link} onChange={set("link")} data-testid="sojourns-link" />
      </div>
      {apply && (
        <div className="sj-field">
          <label htmlFor="sj-goal">The one goal you'd bring</label>
          <input id="sj-goal" type="text" name="goal" value={form.goal} onChange={set("goal")} required data-testid="sojourns-goal" />
        </div>
      )}
      <div className="sj-honey" aria-hidden="true">
        <label htmlFor="sj-website">Website</label>
        <input id="sj-website" type="text" name="website" tabIndex={-1} autoComplete="off" value={form.website} onChange={set("website")} />
      </div>
      <label className="sj-check" htmlFor="sj-consent">
        <input id="sj-consent" type="checkbox" name="consent" checked={form.consent} onChange={set("consent")} required data-testid="sojourns-consent" />
        <span>
          Email me about Savi Sojourns. I can unsubscribe at any time. <a href="https://www.savicoliving.com/privacy" target="_top" data-testid="sojourns-privacy-link">Privacy policy</a>
        </span>
      </label>
      {error && <p className="sj-error" role="alert" data-testid="sojourns-error">{error}</p>}
      <button type="submit" className="sj-btn" disabled={sending} data-testid="sojourns-submit">
        {sending ? "Sending" : apply ? "Apply" : "Keep me posted"}
      </button>
    </form>
  );
}
